import axios from '@/utils/api.request'
// import axios from 'axios'
let previousUrl = '/api'
// 质量保修api
// 获取新增或修改案件所需默认的数据
export const getDetailData = (caseNo) => {
  return axios.request({
    url: `${previousUrl}/dtr/caseNo/${caseNo.caseNo}/${caseNo.vin}`,
    method: 'get'
  })
}

export const getDetailDatas = (caseNo) => {
  return axios.request({
    url: `${previousUrl}/dtr/${caseNo.id}`,
    method: 'get'
  })
}

// 保存草稿
export const saveDraft = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/draft`,
    method: 'post',
    data: data
  })
}
export const saveDraft1 = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/attaDraft/${data}`,
    method: 'get'
  })
}

// 提交案件
export const submitCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/submit/${data.caseNo}/${data.vin}`,
    method: 'get'
  })
}
export const submitCase1 = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/attaSubmit/${data}`,
    method: 'get'
  })
}

// 获取一个案件
export const getCaseItem = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/${data}`,
    method: 'get'
  })
}

// 打回附件
export const rejectCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/rejectAtta/${data.caseNo}/${data.vin}/${data.attaId}`,
    method: 'get'
  })
}

// 承认附件
export const confirmCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/confirmAtta/${data.caseNo}/${data.vin}/${data.attaId}`,
    method: 'get'
  })
}

// 按人打回附件
export const rejectCaseByUser = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/rejectAttaByUser/${data.caseNo}/${data.vin}/${data.userId}`,
    method: 'get'
  })
}
// 按人承认附件
export const confirmCaseByUser = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/confirmAttaByUser/${data.caseNo}/${data.vin}/${data.userId}`,
    method: 'get'
  })
}

// 全部打回附件
export const rejectCaseByCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/rejectAttaByCase/${data.caseNo}/${data.vin}`,
    method: 'get'
  })
}
// 全部承认附件
export const confirmCaseByCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/confirmAttaByCase/${data.caseNo}/${data.vin}`,
    method: 'get'
  })
}

// 添加单条附件
export const addOneCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/addAtta/${data.caseNo}/${data.vin}/${data.id}`,
    method: 'get'
  })
}

//  删除单挑附件
export const removeOneCase = (data) => {
  return axios.request({
    url: `${previousUrl}/dtr/delAtta/${data.caseNo}/${data.vin}/${data.id}`,
    method: 'get'
  })
}

// 获取列表
export const getItems = (pageNo, size, data) => {
  return axios.request({
    url: `${previousUrl}/dtr/items/${data.status}?page=${pageNo}&ize=${size}`,
    method: 'post',
    data: data
  })
}
// 获取列表
export const getItems4tmci = (pageNo, size, data) => {
  return axios.request({
    url: `${previousUrl}/dtr/items?page=${pageNo}&ize=${size}`,
    method: 'get',
    data: data
  })
}

// 获取案件数量
export const getCount = () => {
  return axios.request({
    url: `${previousUrl}/dtr/count`,
    method: 'get',
  })
}
